import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BannerCardComponent } from '@shared/components/banner-card/banner-card.component';
import { IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';
import { CreatorsKpiCardsComponent } from './creators-kpi-cards/creators-kpi-cards.component';

@Component({
  imports: [BannerCardComponent, TranslateModule, CreatorsKpiCardsComponent],
  selector: 'app-creators-banner',
  templateUrl: './creators-banner.component.html',
})
export class CreatorsBannerComponent {
  public readonly addButtonConfiguration = input<ICreateEntityButtonConfiguration | null>(null);

  private readonly translate = inject(TranslateService);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.creators.banner.title'),
      link: '/dashboard',
    },
  ];
}
